<template>
  <div :class="$style.alert">
    <div>
      <IconAlert :class="$style.icon" />
    </div>
    <div>
      <slot></slot>
    </div>
  </div>
</template>

<script setup lang="ts">
import IconAlert from '@/components/icons/IconAlert.vue'
// eslint-disable-next-line @typescript-eslint/no-unused-expressions
IconAlert
</script>

<style module lang="scss">
.alert {
  display: flex;
  gap: 10px;
  border-radius: 8px;
  background: #fff1ce;
  padding: 16px;
}

.icon {
  fill: $color-text-and-object-accent-orange;
  font-size: 24px;
}
</style>
